/**
 * Site-wide frontend JS — enqueued globally via SiteScripts.php.
 */
import { initSliderNavState } from './components/slider-nav-state.js';

initSliderNavState();

import { initTableLayout } from './components/table-layout.js';

initTableLayout();
